import React, { Component } from "react";
import { useState, useEffect } from 'react'
import store from "@/redux/store";

import { MagnifyingGlassIcon, QuestionMarkCircleIcon } from '@heroicons/react/20/solid'
import {
  Bars3Icon,
  BellIcon,
  CogIcon,
  CreditCardIcon,
  KeyIcon,
  SquaresPlusIcon,
  UserCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'


import { BuildingOfficeIcon, UserIcon, UsersIcon, PencilIcon, TrashIcon } from '@heroicons/react/20/solid'

import { Company } from "@/views/Settings/Company";
import { Invoice } from "@/views/Settings/Invoice";
import { Interest } from "@/views/base/user/Interest";
import {storeBaseSetting2, removeBaseSetting} from "@/reducers/Settings";
import {showConfirmModal, hideModal} from "@/reducers/ModalPopup";

export function VatRateSettingsView({...props}) {
    const [settings, setSettings] = useState((props.SettingsReducer && props.SettingsReducer.settings_vatrates) ? props.SettingsReducer.settings_vatrates : []);
    const [action, setAction] = useState("");

    const editItem = (event, item) => {
        setAction( item.key );
    }
    const cancel = (event) => {
        let newArray = [...props.SettingsReducer.settings_vatrates];
        setSettings( newArray );
        setAction( "" );
    }
    const addItem = (event) => {
        let key = "NEW";
        let obj = {key:key, name: "Invullen", percentage: 0.00};
        let newArray = [...settings, obj];
        setSettings( newArray );
        setAction( key );
        return false;
    }
    
    const saveItem = (event) => {
        event.preventDefault();
        event.stopPropagation();
    
        const data = new FormData(event.target);
        const values = Object.fromEntries(data.entries());
        store.dispatch( storeBaseSetting2( {data: values, type: "vat"} ) );

//        setAction( "" );
        return false;

    }    

    const removeItem = (event, item) => {
        event.preventDefault();
        event.stopPropagation();
    
        store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));

//        setAction( "" );
        return false;

    }    

const confirmedRemoveHandler = (props) => {
    store.dispatch( removeBaseSetting({data: props.item, type: "vat"}) );
    store.dispatch(hideModal(null));
}
    
//    const {settings_vatrates} = SettingsReducer;
         return (
<form onSubmit={saveItem}>
                    {action != ""  &&
                        <input name="key" type="hidden" defaultValue={action} />
                    }


                  <div className="shadow sm:overflow-hidden sm:rounded-md">
                    <div className="bg-white px-4 py-6 sm:p-6">
                        {settings && settings.length >= 0 && 
          <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0 w-4">
                    <span className="sr-only">Edit</span>
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Naam
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-12">
                    Tarief
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {settings.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 flex">
                        {action == "" &&
                        <>
                        <TrashIcon className="w-3 h-5 cursor-pointer" onClick={() => removeItem(event, item)}/>
                        <PencilIcon className="w-3 h-5 cursor-pointer" onClick={() => editItem(event, item)}/>
                        </>
                        }
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {action != "" && action == item.key &&
                        <input name="name" type="text" defaultValue={item.name} />
                    }
                    {action == "" && 
                    item.name
                    }
                    {action != "" && action != item.key && 
                    <span className="text-gray-200">{item.name}</span>
                    }
                    
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    
                    {action != "" && action == item.key &&
                        <input name="percentage" type="text" defaultValue={item.percentage} />
                    }
                    {action == "" && 
                    item.percentage
                    }
                    {action != "" && action != item.key && 
                    <span className="text-gray-200">{item.percentage}</span>
                    }
                    
                    
                    </td>
                        
                        
                    </tr>                        
                ))}
              </tbody>
            </table>
            }
                    </div>
                    
                    <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">
                    {action == "" && 
                      <button
                        onClick={() => addItem(event)}
                        type="button"
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Toevoegen
                      </button>
                      }
                      
                    {action != "" &&
                        <>
                      <button
                        type="button"
                        onClick={() => cancel(event)}
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Annuleren
                      </button>
 
                      <button
                        type="submit"
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Bewaren
                      </button>
                      </>
                      }
                      
                      
                    </div>
                    
                  </div>
                  
                </form>
    );    
}